export default [
  {
    path: '/main/shippingdestinytransportation',
    meta: {
      tag: 'list_shipping_destiny_transportation',
      name: 'Destino de Envio de Transporte',
      breadcrumb: 'Destino de Envio de Transporte'
    },
    component: () => import(/* webpackChunkName: "shipping-destiny-transportation-list" */ '@/views/main/settings/test-registers/shippingdestinytransportation/Index.vue'),
    children: [
      {
        path: '',
        name: 'listshippingdestinytransportation',
        meta: {
          tag: 'list_shipping_destiny_transportation',
          menu: 'settings',
          name: 'Destino de Envio de Transporte'
        },
        component: () => import(/* webpackChunkName: "shipping-destiny-transportation-list" */ '@/views/main/settings/test-registers/shippingdestinytransportation/List.vue')
      },
      {
        path: '/main/shippingdestinytransportation/add',
        name: 'addshippingdestinytransportation',
        meta: {
          tag: 'add_shipping_destiny_transportation',
          menu: 'settings',
          name: 'Adicionar | Destino de Envio de Transporte',
          breadcrumb: 'Adicionar Destino de Envio de Transporte'
        },
        component: () => import(/* webpackChunkName: "shipping-destiny-transportation-add" */ '@/views/main/settings/test-registers/shippingdestinytransportation/Add.vue')
      },
      {
        path: '/main/shippingdestinytransportation/:id',
        name: 'editshippingdestinytransportation',
        meta: {
          tag: 'edit_shipping_destiny_transportation',
          menu: 'settings',
          name: 'Editar | Destino de Envio de Transporte',
          breadcrumb: 'Editar Destino de Envio de Transporte'
        },
        component: () => import(/* webpackChunkName: "shipping-destiny-transportation-edit" */ '@/views/main/settings/test-registers/shippingdestinytransportation/Edit.vue')
      }
    ]
  },
]
